export interface State {
  detail: Array<DetailType>
  detailStatus: Number
  usersDetail: Array<UsersDetailType>
  usersDetailN: Array<UsersDetailType>
  editUsersList: Array<UsersDetailType>
  usersDetailAll: Array<UsersDetailType>
  usersDetailAllSame: Array<UsersDetailType>
  checkedList: Array<UsersDetailType>
  detailSame: Array<UsersDetailType>

  //フォルダの利用者登録画面表示フラグ
  modalUserInfoAddActived: boolean
  //apiから取得する利用者一覧データ
  originUserInfoLists: Array<UsersDetailType>
  //表示用に変換した利用者一覧データ バックアップ用
  backupUserInfoLists: Array<UsersDetailType>
  //表示用に変換した利用者一覧データ 検索結果表示用
  displayUserInfoLists: Array<UsersDetailType>
  //利用者一覧　テーブル表示用
  tableUserInfoLists: Array<UsersDetailType>
  //検索欄に入力ある場合、検索結果を表示用利用者一覧データ
  searchserUserInfoLists: Array<UsersDetailType>
}
export interface DetailType {
  folder_id: string
  display_flag: boolean
  read_flag: boolean
  folder_type: string
  public_category: string
  parent_folder_id: number
  forder_name: string
  recipient_id: number
  recipient_name: string
  update_datetime: string
  insert_datetime: string
  family_name: string
  given_name: string
  insert_user_name: string
}
export interface UsersDetailType {
  user_id: number
  employee_code: string
  family_name: string
  given_name: string
  name?: string
  email: string
  department: string
  role_code: string
  role_name: string
  insert_datetime: string
  display_in_list: boolean
}

const state = (): State => ({
  detail: [],
  detailStatus: 0,
  usersDetail: [],
  usersDetailAll: [],
  usersDetailAllSame: [],
  detailSame: [],
  usersDetailN: [],
  editUsersList: [],
  checkedList: [],
  modalUserInfoAddActived: false,
  originUserInfoLists: [] as Array<UsersDetailType>,
  backupUserInfoLists: [] as Array<UsersDetailType>,
  displayUserInfoLists: [] as Array<UsersDetailType>,
  tableUserInfoLists: [] as Array<UsersDetailType>,
  searchserUserInfoLists: [] as Array<UsersDetailType>,
})

export default state
